import { render, staticRenderFns } from "./SV.vue?vue&type=template&id=312d48e8&scoped=true"
import script from "./SV.vue?vue&type=script&lang=js"
export * from "./SV.vue?vue&type=script&lang=js"
import style0 from "./SV.vue?vue&type=style&index=0&id=312d48e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d48e8",
  null
  
)

export default component.exports